@if (theme?.footer?.show) {
  <ng-template #footerLinks let-links="links">
    @for (link of links?.slice(0, 6); track $index) {
      <id-link [attr.slot]="'link-col-' + (Math.floor($index / 2) + 1)">
        <a [href]="link.url" [title]="link.title">
          @if (link.externalLink) {
            <span class="ids-icon-arrow-right-small ids-icon--text-start" aria-hidden="true"></span>
          }
          {{ link.title }}
        </a>
      </id-link>
    }
  </ng-template>

  <ng-template #ineraSubFootersRight>
    <p slot="sub-footer-right">
      Legitimeringstjänsten drivs av
      <id-link [small]="true" [underlined]="true" [colorpreset]="3">
        <a href="#">
          <span>
            Inera AB
            <span class="ids-icon-external-link-small ids-icon--text-end" aria-hidden="true"></span>
          </span>
        </a>
      </id-link>
      på uppdrag av Sveriges regioner
    </p>
  </ng-template>

  <ng-template #subFooterLeft>
    <p class="wt-footer" slot="sub-footer-left">
      1177
      <id-link [small]="true" [underlined]="true" [colorpreset]="3">
        <a href="#">
          <span>
            Inera AB
            <span class="ids-icon-external-link-small ids-icon--text-end" aria-hidden="true"></span>
          </span>
        </a>
      </id-link>
      på uppdrag av Sveriges regioner
    </p>
  </ng-template>

  @if (theme.theme.mainTheme === 'Inera-admin') {
    <id-footer-inera-admin [headline]="theme.footer.name || 'IdP'">
      <p>
        {{ theme.footer.text }}
      </p>
      <ng-container *ngTemplateOutlet="footerLinks; context: { links: theme?.footer?.links }"></ng-container>
      <ng-container *ngTemplateOutlet="ineraSubFootersRight"></ng-container>
      <p slot="sub-footer-mobile">
        Tjänsten drivs av
        <id-link endicon="external-link-small">
          <a href="https://www.inera.se">Inera AB</a>
        </id-link>
        på uppdrag av Sveriges regioner.
      </p>
    </id-footer-inera-admin>
  } @else if (theme.theme.mainTheme === '1177') {
    <id-footer-1177 headline="IdP">
      <p>
        {{ theme.footer.text }}
      </p>
    </id-footer-1177>
  } @else if (theme.theme.mainTheme === '1177-pro') {
    <id-footer-1177-pro headline="IdP">
      <div slot="bottom-footer-text">
        <p>
          {{ theme.footer.text }}
        </p>
      </div>
    </id-footer-1177-pro>
  } @else if (theme.theme.mainTheme === '1177-admin') {
    <id-footer-1177-admin [headline]="theme.footer.name">
      <p>
        {{ theme.footer.text }}
      </p>
      <ng-container *ngTemplateOutlet="footerLinks; context: { links: theme?.footer?.links }"></ng-container>
      <ng-container *ngTemplateOutlet="subFooterLeft"></ng-container>
    </id-footer-1177-admin>
  } @else {
    <footer id="footer" class="custom-footer">
      <div class="footer-container">
        <div class="footer-branding">
          <h2 class="footer-title">{{ theme.theme.name }}</h2>
          <p class="footer-text">{{ theme.footer.text }}</p>
        </div>
        <div class="footer-links">
          <!-- Users can add custom links here through theme settings -->
        </div>
      </div>
    </footer>
  }
}
